import React from 'react'
import { AdvancedSearchStepper } from '../composants/adresse/AdvancedSearchStepper'

export const AdvancedSearchPage = () => {
  return <AdvancedSearchStepper />
}
